import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { moduleSelector } from '../../module';
import { summaryKey } from '../../reducers';

export const parentSelector = createSelector(moduleSelector, get(summaryKey));
